import src from "IMAGE";
export default { src, width: 132, height: 104, blurWidth: 0, blurHeight: 0};
